import { render, staticRenderFns } from "./Violations.vue?vue&type=template&id=5e49c2b4&"
import script from "./Violations.vue?vue&type=script&lang=ts&"
export * from "./Violations.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports